import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import $ from 'jquery';
import logo from 'images/header-logo.png';
import css from '../styles/nav.css';
const { Component } = React;

class Nav extends Component {
  constructor() {
    super();
    this.scrollHandler = this.scrollHandler.bind(this);
    this.state = {
      scrolled: false
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', this.scrollHandler);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.scrollHandler);
  }

  scrollHandler() {
    let scrollY = $(window).scrollTop();

    if (!this.state.scrolled && (scrollY > 50)) {
      this.setState({scrolled: true});
    } else if (this.state.scrolled && (scrollY <= 50)) {
      this.setState({scrolled: false});
    }
  }

  activeClasses(scrolled) {
    let list = ['nav'];
    if (scrolled) {
      list.push('static');
    }

    return list;
  }

  render() {
    const { items } = this.props;
    const { scrolled } = this.state;

    return (
      <nav className={this.activeClasses(scrolled).join(' ')}>
        <ul className="nav-list">
          <li className="nav-list__item"><Link to={items[0].path}>{items[0].label}</Link></li>
          <li className="nav-list__item"><Link to={items[1].path}>{items[1].label}</Link></li>
          <li className="nav-list__item"><Link to="/"><img src={logo} alt="" /></Link></li>
          <li className="nav-list__item"><Link to={items[2].path}>{items[2].label}</Link></li>
          <li className="nav-list__item"><Link to={items[3].path}>{items[3].label}</Link></li>
        </ul>
      </nav>
    )
  }
}

function mapStateToProps(state) {
  return {
    items: state.nav.items
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

const NavContainer = connect(mapStateToProps, mapDispatchToProps)(Nav);

export {Nav, NavContainer};



// WEBPACK FOOTER //
// ./app/screens/App/components/nav.js